import { PATHS } from '@/constants/page-paths';

export const desktopNavItems = [
  { key: 'home', path: PATHS.HOME, title: 'Home' },
  { key: 'chat', path: PATHS.CHAT, title: 'Chat' },
  { key: 'my_twin', path: PATHS.MY_TWIN, title: 'My Twin' },
  { key: 'studio', path: PATHS.TWIN_STUDIO, title: 'Studio' },
  {
    key: 'get_twin',
    path: PATHS.TWIN_LANDING,
    title: 'Get your Twin',
  },
];

export const mobileNavItems = [
  { key: 'home', path: PATHS.HOME, title: 'Home' },
  { key: 'chat', path: PATHS.CHAT, title: 'Chat' },
  { key: 'my_twin', path: PATHS.MY_TWIN, title: 'My Twin' },
  { key: 'studio', path: PATHS.TWIN_STUDIO, title: 'Studio' },
  { key: 'profile', path: PATHS.PROFILE, title: 'Profile' },
  { key: 'buy_points', path: PATHS.BUY_POINTS, title: 'Buy Points' },
  { key: 'help_feedback', path: PATHS.FEEDBACK, title: 'Help & Feedback' },
  {
    key: 'get_twin',
    path: PATHS.TWIN_LANDING,
    title: 'Get your Twin',
  },
];

export const unAuthenticatedNavItems = [
  {
    key: 'home',
    path: PATHS.HOME,
    title: 'Home',
  },
  {
    key: 'get_twin',
    path: PATHS.TWIN_LANDING,
    title: 'Get your Twin',
  },
  {
    key: 'studio',
    path: PATHS.TWIN_STUDIO_LANDING,
    title: 'Studio',
  },
  {
    key: 'help_and_feedback',
    path: PATHS.FEEDBACK,
    title: 'Help & Feedback',
  },
];
